const login = {
    login: "Giriş Yap",
    phone: "Telefon",
    email: "E-posta",
    erCode: "QR Kod",
    phoneNo: "Telefon Numarası",
    sryx: "Lütfen e-posta girin",
    password: "Şifre",
    wjmm: "Şifrenizi mi unuttunuz?",
    srmm: "Lütfen şifrenizi girin",
    myzh: "Henüz hesabınız yok mu?",
    ljzc: "Hemen Kaydol",
    cxsm: "Yeniledikten sonra biking App ile tekrar tarayın",
    xydl: "Lütfen telefonunuzdan girişi onaylayın",
    smewm: "Biking App'te profil simgesine tıklayın, ardından sağ üstteki simgeye basarak QR kodunu tarayın",
    qtfs: "Diğer Giriş Yöntemleri",
    ggsfyz: "Google Kimlik Doğrulama",
    bdsj: "Telefonunuz bağlandı",
    bdyx: "E-postanız bağlandı",
    fsyzm: "Doğrulama Kodunu Gönder",
    wcyz: "Lütfen doğrulamayı tamamlayın",
    dlcg: "Giriş başarılı, biking'e hoş geldiniz!",
    bktb: "Güvenlik nedeniyle, hesap güvenlik ayarları değiştirildikten sonra 24 saat içinde para çekilemez",
    fhdl: "Giriş sayfasına dön",
    jx: "Devam Et",
    cxfs: "Yeniden Gönder",
    gxmm: "Şifreyi Güncelle",
    srsjh: "Lütfen telefon numarası girin",
    wjmm1: "Şifremi Unuttum",
    sryxdz: "Lütfen e-posta adresini girin",
    srzqyx: "Lütfen geçerli bir e-posta adresi girin",
    sryzm: "Doğrulama kodunu girin",
    czmm: "Şifreyi Sıfırla",
    sbdyzm: "Doğrulama kodu gelmiyor mu?",
    srxmm: "Lütfen yeni şifreyi girin",
    zczh: "Biking Hesabı Oluştur",
    yqm: "Davet Kodu (isteğe bağlı)",
    sryqm: "Lütfen davet kodunu girin",
    zc: "Kaydol",
    yyzh: "Zaten hesabınız var mı?",
    ljdl: "Hemen Giriş Yap",
    fsz: "Doğrulama kodu şuraya gönderildi:",
    next: "Sonraki",
    szmm: "Şifre Belirle",
    submit: "Gönder",
    zccg: "Kayıt başarılı!"
}
const download = {
    title: "Çeşitlendirilmiş oyun ve<br/>dijital para işlem platformu",
    subTitle: "Biking ile yüzlerce dijital para işlemi yapabilirsiniz",
    xzbw: "Neden Biking'i Seçmelisiniz",
    czzz: "Biking, zenginlik yaratmanıza, değer katmanıza ve korumanıza yardımcı olur",
    download: "App Store'dan İndir",
    downloadtf: "TestFlight'tan İndir",
    cjqxz: "Süper İmzalı İndirme",
    cjq: "Süper İmza {index}",
    bdxz: "Yerel İndirme",
    ggpxz: "Google Play'den İndir",
    advantageTitle1: "Üstün Performans · Işık Hızında İşlem",
    subTitleSubTitle1: "Londra Borsası teknolojisiyle desteklenen, ultra düşük gecikme, süper hızlı eşleştirme",
    advantageTitle2: "Varlık Koruma · Maksimum Güvenlik",
    subTitleSubTitle2: "Biking CCSS standartlarına uygundur, varlıklarınızı ve verilerinizi korur",
    advantageTitle3: "7/24 Hizmet",
    subTitleSubTitle3: "Sistemin kesintisiz çalışmasını sağlar, 7/24 müşteri hizmeti sunar",
    qhidxq: "ID Değiştirme Detayları",
    step1: "Birinci Adım",
    step2: "İkinci Adım",
    step3: "Üçüncü Adım",
    step4: "Dördüncü Adım",
    step5: "Beşinci Adım",
    step6: "Altıncı Adım",
    step7: "Yedinci Adım",
    step8: "Sekizinci Adım",
    step9: "Dokuzuncu Adım",
    step10: "Onuncu Adım",
    azBiking: "App Store üzerinden Biking'i yükleyin",
    dlxz: "Eğer Çin ana karası dışından bir App ID'niz varsa, doğrudan App Store'a giriş yapıp indirebilirsiniz",
    fdlid: "Çin ana karası dışından bir App ID edinin",
    yxfshq: "Eğer Çin ana karası dışından bir App ID'niz yoksa, aşağıdaki yöntemlerle edinebilirsiniz",
    qhid: "App Store'da Apple ID değiştirme",
    dk: "1. Açın",
    ysjtx: "App Store uygulamasını, App Store sağ üstteki avatar simgesine tıklayın",
    cxsrmm: "2. Çıkış yapın, Apple ID ve şifreyi tekrar girin",
    wfdl: "* Eğer 'Giriş yapılamıyor' hatası alırsanız, son zamanlarda çok sık ID değiştirmiş olabilirsiniz, farklı bir ID deneyin veya birkaç saat sonra tekrar deneyin. Eğer ID kilitlendiyse, doğrulama yapmanız veya farklı bir ID denemeniz gerekebilir",
    azapp: "Uygulamayı Yükle",
    storesh: "1. Giriş başarılı olduktan sonra, ilgili bölgenin App Store'una yönlendirileceksiniz, App Store'da 'Biking' arayın, 'İndir' butonuna tıklayın, uygulamayı yüklemeye başlayın",
    jxxz: "Çin ana karası dışı Apple ID'm var, indirmeye devam et",
    jxxz1: "İndirmeye Devam Et",
    way1: "Yöntem 1",
    wayTitle1: "Kendiniz kaydolun, güvenli ve stabil",
    wayBtn1: "Nasıl kaydolunur görüntüle",
    way2: "Yöntem 2",
    wayTitle2: "Platform referans ID'leri (kolay ve hızlı)",
    wayBtn2: "Referans ID'leri görüntüle",
    way3: "Yöntem 3",
    wayTitle3: "Ülke/bölge rehberi (serbestçe değiştirin)",
    wayBtn3: "Nasıl satın alınır görüntüle",
    ckzh: "Çin Ana Karası Dışı Apple ID Referans Hesapları",
    jgck: "Aşağıdaki yurtdışı ID'leri referans için kullanabilirsiniz",
    jjfz: "(Hesap veya şifreyi kopyalamak için tıklayın)",
    zh: "Hesap",
    mm: "Şifre",
    xxxl: "Telefon bilgilerinizin sızmasını önlemek için",
    dlicloud: "Lütfen yukarıdaki Apple ID ile ICloud'a giriş yapmayın",
    tczh: "Referans Apple ID ile uygulamayı indirdikten sonra, lütfen hesaptan çıkış yapın",
    cfsy: "Lütfen telefon numarası bağlamayın, aksi halde ID tekrar kullanılamaz",
    jrql: "QR kodu tarayarak sohbet grubuna katılın",
    lxkf: "Müşteri Hizmetleriyle İletişime Geçin",
    zjzc: "Kendi Yurtdışı ID'nizi Oluşturun",
    registerStep1: "Birinci Adım appleid ana sayfasını açın",
    registerStep2: "İkinci Adım E-postayı doğrulayın",
    registerStep3: "Üçüncü Adım App Store hesabından çıkış yapın",
    registerStep4: "Dördüncü Adım Store'da yeni oluşturulan ID ile giriş yapın",
    gwzcwz: "Safari tarayıcısında Apple resmi kayıt sitesini açın:",
    yzdzyx: "Tüm bilgileri doldurup devam ettikten sonra, Apple ID doğrulama e-postası alacaksınız, e-posta doğrulama kodunu girmeniz gerekiyor",
    tjfkfs: "Ardından otomatik olarak Apple ID yönetim sayfasına yönlendirileceksiniz (yüklenmesi biraz zaman alabilir), yönetim sayfasına girdikten sonra, Ödeme ve Teslimat'a tıklayın ve sonraki sayfada Ödeme Yöntemi Ekle'ye tıklayın",
    mgsfzsc: "En kritik aşamaya geldik, ödeme yönteminin 'Yok' olup olmadığını kontrol edin, eğer 'Yok' ise dokunmayın, ülke veya bölge Amerika veya kaydolmak istediğiniz bölge mi, diğer içerikleri istediğiniz gibi doldurabilirsiniz. Ancak İngilizce doldurmak daha iyidir, eyalet/şehir olarak Alaska'yı seçin, çünkü bu bölge vergiden muaftır, uygulama satın alırken de vergi ödemezsiniz. Kişisel bilgileri şu site üzerinden oluşturabilirsiniz: Amerikan kimlik oluşturucu",
    gxdqxx: "Doldurduktan sonra Güncelle'ye tıklayın, bölge bilgilerini güncelleyin",
    zhxx: "1. App Store'a girin, sağ üstteki avatara tıklayın, hesap sayfasına girin",
    djwc: "2. Sayfayı aşağı kaydırın, 'Çıkış Yap'a tıklayarak mağaza ID'sinden çıkış yapın, ardından 'Tamam'a tıklayın",
    jrzhdl: "1. Tekrar sağ üstteki avatara tıklayın, hesap giriş sayfasına girin",
    zhmmdl: "2. Hesap ve şifreyi girin, 'Giriş Yap'a tıklayın",
    jydlcg: "3. Doğrulama kodunu girin, başarılı doğrulamadan sonra Apple ID ile giriş yapmış olursunuz",
    jysssd: "İşlemler her zaman, her yerde",
    smewm: "QR Kodunu Tara",
    xiazai: "İndir",
    huodong: "Etkinlikler",
    title1: "Biking Çeşitlendirilmiş Oyun",
    title2: "ve Dijital Para İşlem Platformu",
    open: "'Biking' App içinde aç",
    ggzx: "Duyuru Merkezi",
    lscb: "Blokzincir Para Yatırma",
    fbrj: "Nakit Para Yatırma",
    tgaq: "Kullanıcılara daha güvenli hizmet sunmaya adanmıştır",
    wdjmzc: "Stabil kripto varlık türevleri işlem hizmeti",
    szhbjy: "Dijital para işleminde biz uzmanız",
    yxhsjh: "E-posta/telefon numarası ile kaydolun"
}
export { login, download }


// WEBPACK FOOTER //
// ./src/i18n/lang/login/tr.js